(function(){
	// the visitor timeline (tmJwtIdentifier, tmVisitorActions, coolLastTrackedUrl) is Analytics: stored and sent only with
	// consent (vault 40 Platform/Consent banner.md, Flow 6). Without it the chat still works: its identifier stays in memory.
	function analyticsAllowed() {
		try {
			if (window.TmConsent && typeof window.TmConsent.allowed === 'function') {
				return window.TmConsent.allowed('analytics');
			}
			return !!(window.tmConsentState && window.tmConsentState.choice && window.tmConsentState.choice.a);
		} catch (e) {
			return false;
		}
	}

	class CoolEvents {
		isLocalStorageAvailable = true;
		nonce = '';
		identifierInMemory = '';

		constructor() {
			let test = 'test';

			try {
			    localStorage.setItem(test, test);
			    localStorage.removeItem(test);
			} catch(e) {
				this.isLocalStorageAvailable = false;
			}
		}

		getTmIdentifier() {
			if(!this.isLocalStorageAvailable || !analyticsAllowed()) {
				return this.identifierInMemory;
			}

			return localStorage.getItem('tmJwtIdentifier') || this.identifierInMemory;
		}

		setTmIdentifier(identifier) {
			this.identifierInMemory = identifier || '';
			if(this.isLocalStorageAvailable && analyticsAllowed()) {
				localStorage.setItem('tmJwtIdentifier', identifier);
			}
		}

		async sendVisitorAction(eventData = false) {
			if(!this.isLocalStorageAvailable || !analyticsAllowed()) {
				return false;
			}

			const identifier = this.getTmIdentifier();

			let visitorActions = localStorage.getItem('tmVisitorActions');

			if(visitorActions) {
				visitorActions = JSON.parse(visitorActions);
			}
			else {
				visitorActions = [];
			}

			if(!identifier) {
				// Save action for later

				if(eventData) {
					eventData.created_at = new Date().toISOString();

					visitorActions.push(eventData);

					localStorage.setItem('tmVisitorActions', JSON.stringify(visitorActions));
				}
			}
			else {
				if(eventData) {
					eventData.created_at = new Date().toISOString();
					visitorActions.push(eventData);
				}

				if(visitorActions.length) {

					let nonce = await this.waitForNonce();

					let options = {
						method: "POST",
						headers: {
						    "Content-Type": "application/x-www-form-urlencoded",
						},
						body: jQuery.param({
							action: 'visitor_action',
							identifier: identifier,
							eventData: visitorActions,
							nonce: nonce
						})
					};

					const json = await this.ajaxJson(options);

					if(!json) {
						return true; // an error: trackPageView leaves coolLastTrackedUrl as it was
					}

					if(!json.error) {
						localStorage.removeItem('tmVisitorActions');
					}

					//console.log(json);

					return json.error;
				}
			}

			return true;
		}

		async visitorProvidedDetails(name, email, phone) {
			let identifier = this.getTmIdentifier();

			let options = {
				method: "POST",
				body: new URLSearchParams({
					action: 'visitor_provided_details',
				    name: name,
				    email: email,
				    phone: phone,
				    identifier: identifier,
				})
			};

			const json = await this.ajaxJson(options) || {};

			let newIdentifier = json.identifier;

			if(newIdentifier) {
			    this.setTmIdentifier(newIdentifier);

			    zE("messenger", "logoutUser");
			    this.sendVisitorAction();
			}

			return true;
		}

		async trackPageView() {
			// a private page's address carries its link's token (a shared booking): it never goes into the visitor's timeline
			if(window.tmPrivatePage) {
				return;
			}
			// a first visit's region is still being looked up (tm-consent.js): track once it is known, if analytics is allowed then
			if(window.TmConsent && typeof window.TmConsent.known === 'function' && !window.TmConsent.known()) {
				window.TmConsent.ready(() => { this.trackPageView(); });
				return;
			}
			// storage blocked (Safari throws SecurityError on access): the timeline cannot be kept, see the constructor
			if(!this.isLocalStorageAvailable || !analyticsAllowed()) {
				return;
			}

			const urlToTrack = window.location.href;
			const lastTrackedUrl = localStorage.getItem('coolLastTrackedUrl') || '';

			if(lastTrackedUrl != urlToTrack) {
				let eventData = {
					type: 'page_view',
					description: document.title,
					properties: {
						page: {
							display_name: document.title,
							url: window.location.href,
						}
					}
				};

				let isError = await this.sendVisitorAction(eventData);

				//console.log(isError);

				if(!isError) {
					localStorage.setItem('coolLastTrackedUrl', urlToTrack);
				}
			}
			else {
				//console.log('Not tracking duplicate url');
			}

			return true;
		}

		async createIdentifierForAnonymousUser() {
			let options = {
				method: "POST",
				body: new URLSearchParams({action: 'create_identifier_for_anonymous_user'})
			};

			const json = await this.ajaxJson(options) || {};

			let identifier = json.identifier || '';

			if(identifier) {
				this.setTmIdentifier(identifier);
				this.sendVisitorAction();
			}

			return json.identifier;
		}

		async getChatAuthToken() {
			let token = '';
			let identifier = coolEvents.getTmIdentifier();

			if(!identifier) {
				identifier = await this.createIdentifierForAnonymousUser();
			}

			if(identifier) {
				let options = {
					method: "POST",
					body: new URLSearchParams({
						action: 'visitor_identifier_token',
						identifier: identifier
					})
				};

				const json = await this.ajaxJson(options) || {};

				token = json.data || '';
			}

			return token;
		}

		async setupVisitorAndTriggerChatOpen() {
			let chatAuthToken = await this.getChatAuthToken();

			if(chatAuthToken) {
				zE("messenger", "loginUser", function(callback){
					callback(chatAuthToken);
				});
			}

			zE("messenger", "open");
			zE("messenger", "show");

			return true;
		}

		async triggerChatOpen() {
			let name = tmVisitorStore.getDetail('name');
			let email = tmVisitorStore.getDetail('email');
			let phone = tmVisitorStore.getDetail('phone');

			zE("messenger", "logoutUser");

			let identifier = this.getTmIdentifier();

			let options = {
				method: "POST",
				body: new URLSearchParams({
					action: 'trigger_chat_open',
					identifier: identifier,
					name: name,
					email: email,
					phone: phone
				})
			};

			const json = await this.ajaxJson(options);

			// no reply: the chat still opens, anonymously, and the stored identifier stays
			if(!json) {
				zE("messenger", "open");
				zE("messenger", "show");
				return true;
			}

			this.setTmIdentifier(json.userToken);

			const chatAuthToken = json.chatToken;

			if(chatAuthToken) {
				zE("messenger", "loginUser", function(callback){
					callback(chatAuthToken);
				});
			}

			if (phone.length > 0) {
				try {
					zE('messenger:set', 'conversationFields', [{ id: '32804813526541', value: phone}])
				} catch (e) {}
			}

			zE("messenger", "open");
			zE("messenger", "show");

			//console.log(json);

			return true;
		}

		// an admin-ajax reply that is not JSON (an empty body after a PHP fatal, a proxy error page, debug output) or a
		// failed request gives null, not a rejection nobody catches (PostHog "… is not valid JSON" with no stack frame on
		// homepages, triage 2026-10-16)
		async ajaxJson(options) {
			try {
				const response = await fetch(ajaxurl, options);
				return response.ok ? await response.json() : null;
			} catch (e) {
				return null;
			}
		}

		async waitForNonce() {
			return await new Promise(resolve => {
				const interval = setInterval(() => {

					let nonce = tmUtils.getAjaxRequestNonce();

					if(nonce != '') {
						resolve(nonce);
						clearInterval(interval);
					}
				}, 1000);
			});
		}
	}

	jQuery(function(){
		window.coolEvents = new CoolEvents();
		$(window).on("load", function() {
			coolEvents.trackPageView();
		});
	});
})()
